"use client";

import Headline from "@/components/static/Headline";
import Section from "@/components/static/Section";
import { HeadlineProps } from "@/lib/types";
import Script from "next/script";
import parse from "html-react-parser";
import Text from "@/components/static/Text";
import { useEffect } from "react";

type Content = {
    settings: {
        padding: {
            bottom: string;
            top: string;
        };
    };
    headline: HeadlineProps;
    text: string;
};

export default function BiteJobListing({ content }: { content: Content }) {
    useEffect(() => {
        // Verzögerung von 1 Sekunde
        const timeoutId = setTimeout(() => {
            const script = document.createElement("script");
            script.src = "https://static.b-ite.com/jobs-api/loader-v1/api-loader-v1.min.js";
            script.async = true;
            script.onload = () => {
                console.log("Skript erfolgreich geladen");
                const biteJobsApi = (window as any).biteJobsApi;
                if (biteJobsApi) {
                    console.log("biteJobsApi verfügbar:", biteJobsApi);
                    // Falls Initialisierung notwendig ist
                    biteJobsApi();
                } else {
                    console.error("biteJobsApi ist nicht verfügbar.");
                }
            };
            document.body.appendChild(script);
        }, 1000); // 1000 ms = 1 Sekunde

        return () => clearTimeout(timeoutId); // Timeout bei unmount abbrechen
    }, []);

    return (
        <Section dataComponent='BiteJobListing' settings={content.settings}>
            <div className='container'>
                <Headline tag={content.headline.tag} topline={content.headline.topline}>
                    {content.headline.title}
                </Headline>
                {content.text && (
                    <Text className='prose md:text-md text-textSecondary'>
                        {parse(content.text)}
                    </Text>
                )}
                <div
                    className='jobWrapper-block mt-8'
                    data-bite-jobs-api-listing='men-metallwerk-elisenhuette:main-listing'
                ></div>
            </div>
        </Section>
    );
}
